// extracted by mini-css-extract-plugin
export default {"navMenuListCollapsed":"NavMenuList_navMenuListCollapsed__dFuXV","navMenuItem":"NavMenuList_navMenuItem__ygOYA","navMenuListExpanded":"NavMenuList_navMenuListExpanded__xLkDj"};